import { render, staticRenderFns } from "./PagesConfigurator.vue?vue&type=template&id=d4a006b8&scoped=true"
import script from "./PagesConfigurator.vue?vue&type=script&lang=js"
export * from "./PagesConfigurator.vue?vue&type=script&lang=js"
import style0 from "./PagesConfigurator.vue?vue&type=style&index=0&id=d4a006b8&prod&scoped=true&lang=css"
import style1 from "./PagesConfigurator.vue?vue&type=style&index=1&id=d4a006b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a006b8",
  null
  
)

export default component.exports